<template>
  <span>
    <span v-html="textoMostrar"></span>
    <a class="secondary--text text--darken-1" v-if="cambio && texto.length > maximo" @click.stop="verMas()">
      <em>... Ver más&nbsp;&gt;</em>
    </a>
    <a class="secondary--text text--darken-1" v-if="!cambio && texto.length > maximo" @click.stop="verMenos()">
      <em>...&lt;&nbsp;Ver menos</em>
    </a>
  </span>
</template>

<script>
/**
 * Componente que crea un span expandible con los botones: "ver mas" y "ver menos"
 */
export default {
  name: 'GlobalSpanExpandible',
  props: {
    /**
     * Texto html a ser renderizado
     */
    texto: {
      type: String,
      default: ''
    },
    /**
     * Length maximo a partir del cual el texto sera replegado
     */
    maximo: {
      type: Number,
      default: 80
    }
  },
  data: () => ({
    textoMostrar: '',
    cambio: false
  }),
  mounted () {
    if (this.texto) {
      this.recortarTexto()
    }
  },
  methods: {
    verMas () {
      this.textoMostrar = this.texto
      this.cambio = !this.cambio
    },
    verMenos () {
      this.textoMostrar = this.texto.substring(0, this.maximo)
      this.cambio = !this.cambio
    },
    recortarTexto () {
      this.textoMostrar = this.texto
      if (this.texto.length > this.maximo) {
        this.cambio = true
        this.textoMostrar = this.texto.substring(0, this.maximo)
      }
    }
  },
  watch: {
    texto () {
      this.recortarTexto()
    }
  }
}
</script>
